import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import PropTypes from "prop-types";
import Navbar from "../common/Navbar";
import Footer from "../common/Footer";
import { getMemberActionIsRead } from "../../actions/memberActions";
import { changePassword } from "../../actions/authActions";
import { isUserAuthenticated } from "../../helpers/authUtils";
import isEmpty from "../../validation/is-empty";
import './change.css';

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
      error: {},
      showModal: "",
      showModalBackdrop: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onClick = this.onClick.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  componentDidMount = () => {
    this.props.getMemberActionIsRead();
  };

  componentDidUpdate(prevProps) {
    if (this.props.errors !== prevProps.errors) {
      this.setState({ error: this.props.errors });
    }

    if (this.props.result !== prevProps.result) {
      if (this.props.result.msg && this.props.result.msg === "Change Password OK") {
        this.setState({ showModal: "show", showModalBackdrop: "modal-backdrop show" });
      }
    }
  };

  handleCloseModal() {
    this.setState({ showModal: "", showModalBackdrop: "" });
    this.props.history.push("/members/logout");
  }

  onClick(e) {
    e.preventDefault();
    const { oldPassword, newPassword, confirmPassword } = this.state;
    const { member } = this.props;

    let error = {};
    if (member.channel==="login") {
      if (isEmpty(oldPassword)) {
        error.oldPassword= "請輸入現在使用的密碼";
      } else {
        if (oldPassword.length < 8) {
          error.oldPassword= "密碼最短長度為 8 碼";
        }
      }
    }

    if (isEmpty(newPassword)) {
      error.newPassword= "請輸入新密碼";
    } else {
      if (newPassword.length < 8) {
        error.newPassword= "密碼最短長度為 8 碼";
      }
      if (newPassword === oldPassword) {
        error.newPassword= "新密碼不可與原密碼相同";
      }
    }

    if (isEmpty(confirmPassword)) {
      error.confirmPassword= "請再次輸入新密碼";
    } else {
      if (confirmPassword.length < 8) {
        error.confirmPassword= "密碼最短長度為 8 碼";
      }
      if (confirmPassword !== newPassword) {
        error.confirmPassword= "兩次輸入的密碼不相同";
      }
    }
    
    if (!isEmpty(error)){
      this.setState({ error: error });
    } else {
      this.setState({ error: {} });
      this.props.changePassword({oldPassword, newPassword, confirmPassword});
    }

  };

  onChange(e) {
    //console.log(e.target.name, e.target.value)
    this.setState({ [e.target.name]: e.target.value });
  }

  renderRedirectToRoot = () => {
    const isAuthTokenValid = isUserAuthenticated();
    if (!isAuthTokenValid) {
      return <Redirect to="/members" />;
    }
  };

  render() {
    const isAuthTokenValid = isUserAuthenticated();
    const { isRead, member } = this.props;
    const { error, oldPassword, newPassword, confirmPassword, showModal, showModalBackdrop } = this.state;
    
    return (
      <Fragment>
        {this.renderRedirectToRoot()}
        {(isAuthTokenValid) && (
        <div id="page">
          <Navbar showMenuLine={true} isRead={isRead} />
          <div className="colorlib" style={{backgroundColor: "#fafafa", borderBottom: "1px solid #CBCBCB"}}>
            <div className="container">
              <div className="row">
                  <div className="col-lg-12">
                    <h1 style={{color: "#000", fontWeight: "700", textAlign: "center", margin: "30px 0px 60px"}}>變更密碼</h1>
                    <div className="form-container">
                      <form>
                        {member.channel==="login" && (
                        <div className="form-group">
                          <input id="oldPassword" name="oldPassword" className="form-control" style={{border: "1.5px solid #000", margin: "0 auto"}} type="password" placeholder="請輸入現在使用的密碼" value={oldPassword} onChange={this.onChange} />
                          {error.oldPassword && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.oldPassword}</span> )} 
                        </div>
                        )}
                        <div className="form-group">
                          <label htmlFor="newPassword" style={{color: "#787878", fontWeight: "600", marginTop: "2rem"}}>請輸入新的密碼</label>
                          <input id="newPassword" name="newPassword" className="form-control" style={{border: "1.5px solid #000", margin: "0 auto"}} type="password" placeholder="請輸入新密碼" value={newPassword} onChange={this.onChange} />
                          {error.newPassword && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.newPassword}</span> )}  
                        </div>  

                        <div className="form-group">
                          <input id="confirmPassword" name="confirmPassword" className="form-control" style={{border: "1.5px solid #000", margin: "0 auto"}} type="password" placeholder="請再次輸入新密碼" value={confirmPassword} onChange={this.onChange} />
                          {error.confirmPassword && (
                          <span className="wrong_msg"><img src="img/icon_wrong.svg" alt="" />{error.confirmPassword}</span> )} 
                        </div> 

                        <div className="form-group">
                          <button type="button" className="btn btn-danger btn-block" style={{margin: "0 auto"}} onClick={this.onClick}>
                          <a href="" style={{color: "#fff", textDecoration: "none", fontSize: "1.5rem"}}> 變更 </a>
                          </button>
                        </div>
                        
                      </form>
                    </div>
                  </div>
              </div>
            </div>
          </div>

          <div className="container mt-3">
            <div className={`modal ${showModal}`} id="myModal" tabIndex="-1" aria-labelledby="myModalLabel" aria-hidden="true">
              <div className="modal-dialog" style={{width: "350px",margin: "250px auto"}}>
                  <div className="modal-content"> 
                      <div className="modal-body"> <img className="icon" src="img/check.png" alt="" />
                          <h3>密碼已變更完成</h3>
                          <p>請重新登入</p>
                      </div>
                      <div className="modal-footer" style={{textAlign: "center", border: "0"}}>
                          <button type="button" className="btn btn-danger" data-bs-dismiss="modal" onClick={this.handleCloseModal}>完成</button>
                      </div>
                  </div>
              </div>
            </div>
          </div>

          <Footer />
          <div className={showModalBackdrop}></div>
        </div>
        )}
      </Fragment>
    );
  }
}

ChangePassword.propTypes = {
  getMemberActionIsRead: PropTypes.func.isRequired,
  changePassword: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  isRead: state.member.isRead,
  member: state.auth.member,
  errors: state.errors,
  result: state.auth.changePasswordResult
});

export default connect(mapStateToProps, { changePassword, getMemberActionIsRead })(ChangePassword);